module.exports = __webpack_public_path__ + "img/staff-2017-reading.b31303a4.jpg";